export default defineNuxtRouteMiddleware(async (to, from) => {
  // Solo lato client per evitare problemi con SSR e cookie
  if (!process.client) {
    return
  }

  const { isAuthenticated, user } = useAuth()

  // Se l'utente è sulla pagina di login
  if (to.path === '/login') {
    // Se è già autenticato, reindirizza alla sua dashboard
    if (isAuthenticated.value) {
      return navigateTo(user.value?.role === 'admin' ? '/dashboard' : '/athlete')
    }
    // Altrimenti lascia accedere alla pagina di login
    return
  }

  // Protegge solo le route /dashboard e /athlete
  const protectedPaths = ['/dashboard', '/athlete']
  const isProtected = protectedPaths.some(path => to.path.startsWith(path))

  if (!isProtected) {
    return
  }

  // Verifica che l'utente sia autenticato
  // Non facciamo fetch qui, lo stato viene gestito dal login e dalle pagine
  if (!isAuthenticated.value) {
    return navigateTo({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }

  // Verifica ruoli: /dashboard solo per admin, /athlete solo per athlete
  if (to.path.startsWith('/dashboard') && user.value?.role !== 'admin') {
    return navigateTo('/athlete')
  }
  if (to.path.startsWith('/athlete') && user.value?.role !== 'athlete') {
    return navigateTo('/dashboard')
  }
})
